<template>
    <div class="visitApplyDetails">
        <van-nav-bar fixed>
            <div slot="left" @click="close" class="icon-title-line">
                <van-icon name="arrow-left" color="#333" class="icon-title-size" />
            </div>
            <div slot="title" class="all-title">智慧校园</div>
        </van-nav-bar>
        <div class="visitApplyDetails-header">
            <van-image width="55" height="55"  :src="require('@/assets/schoolAffairs/success.png')" fit="cover" />
            <p v-if="isShowOut">恭喜您，您预约入校的审批已经通过</p>
            <p v-else>感谢您的拜访，祝您生活愉快</p>
        </div>
        <div class="visitApplyDetails-content">
            <h4>访客信息</h4>
            <ul v-if="thisRows">
                <li>
                    <span>姓名</span>
                    <span>{{thisRows.VisitorName ? thisRows.VisitorName : ''}}</span>
                </li>
                <li>
                    <span>手机号</span>
                    <span>{{thisRows.VisitorPhoneNumber ? thisRows.VisitorPhoneNumber : ''}}</span>
                </li>
                <li>
                    <span>身份证号</span>
                    <span>{{thisRows.VisitorIdCard ? thisRows.VisitorIdCard : ''}}</span>
                </li>
                <li>
                    <span>入校时间</span>
                    <span>{{thisRows.ActualVisitInStr?xy.moment(thisRows.ActualVisitInStr).format('YYYY.MM.DD HH:mm'):''}}</span>
                </li>
                <li v-if="!isShowOut">
                    <span>出校时间</span>
                    <span>{{thisRows.ActualVisitInStr?xy.moment(thisRows.ActualVisitOutStr).format('YYYY.MM.DD HH:mm'):''}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name:'VisitApplyDetails',
    data(){
        return{
            isShowOut:true,
            thisRows:{}
        }
    },
    created(){
        this.getList()
    },
    methods:{
      async getFrequently() {
        this.xy.loading();
        this.list = [];
        let res = await this.xyapi.get(this.xyMApi + "/xy/comm/MobileMoudle")
        if(res.success){
            this.list = res.data.Modules
            for(let i=0;i<this.list.length;i++){
                if(this.list[i].Name === '智慧校务' || this.list[i].ID === 6 || this.list[i].ModuleCode === 'sa'){
                    for(let j=0;j<this.list[i].applications.length;j++){
                          if(this.list[i].applications[j].ApplicationDescription === '访客预约' || this.list[i].applications[j].MID === 6 || this.list[i].applications[j].Code === 'saVisitor'){
                            this.funcBtn(this.list[i],this.list[i].applications[j])
                            console.log(this.list[i],this.list[i].applications[j])
                        }
                    }
                }
            }
        }
        this.xy.unloading();
        },
      funcBtn(pval,vals) {
        this.$store.commit('changeApiPath', `${this.xyMApi}/${pval.ModuleCode}`)
        localStorage.setItem("breadcrumb", JSON.stringify(vals));
        if (vals.MobileUrl) {
          localStorage.setItem("navTitle", vals.Name);
          this.$router.push(vals.MobileUrl);
        } else {
          localStorage.setItem("navTitle", vals.subMenu[0].Name);
          this.$router.push(vals.subMenu[0].ApplicationSubMenuMobileUrl);
        }
        this.$store.commit("common/getMenuIDs", [vals.MID, vals.ID]);
      },  
      close() {
        //this.$router.push({path:'/home/visitList'})
        this.getFrequently()
        },
       async getList() {
            this.xy.loading();
            console.log('请求接口之前')
            let res = await this.xyapi.get(this.xyMApi+'/vst' + "/visitor/GetVisitorRecordAndLog");
            console.log(res)
            this.xy.unloading();
            if (res !== undefined && res.data !== null) {
                this.thisRows = res.data;
                console.log(this.thisRows.IsArrive)  //IsArrive 标识是入校还是出校 IsArrive===true为入校
                this.isShowOut = this.thisRows.IsArrive 
            }else{
                //有token 且 res.data===null的时候进入列表页  
                console.log('我是从visitapplydetail来的')
                this.$router.push({
                    path:'/home/visitSubmission',
                    query:{
                        isFrom:'visitapplydetail'
                    }
                })
            }
        }   
    }
}
</script>
<style lang="less" scoped>
.visitApplyDetails{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    .visitApplyDetails-header{
        margin-top:10%;
        text-align: center;
        p{
            margin-top: 20px;
            color: #333333;
            font-size: 34px;
        }
    }
    .visitApplyDetails-content{
        margin-top: 40px;
        border-top:6px solid #eeeeee;
        padding: 40px;
        h4{
            font-size: 36px;
            color: #161616;
        }
        ul{
            margin-top: 30px;
            li{
                font-size: 30px;
                margin-top: 20px;
                span:nth-child(1){
                    display: inline-block;
                    width: 160px;
                    color: #606060;
                    }
                span:nth-child(2){
                    color: #161616;    
                    } 
            }  
        }
    }
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
</style>